import { CylinderPanel, SpherePanel } from "babylonjs-gui";

export class TreePanel extends SpherePanel {

}